import Breadcrumbs from '@/components/Breadcrumbs'
import SectionHeading from '@/components/ui/SectionHeading'
import Seo from '@/components/Seo'
import { breadcrumbSchema } from '@/lib/schema'

const sections = [
  {
    title: '1. Information We Collect',
    body: 'Mint Calculator does not require an account, and all calculator inputs (income, balances, coin details, etc.) are processed entirely within your browser and are never transmitted to or stored on our servers. We may collect standard, non-identifying analytics data such as pages visited, device type, and approximate location via aggregated, anonymized web analytics.',
  },
  {
    title: '2. Cookies & Advertising',
    body: 'We use cookies to support site functionality and to serve contextual advertising through third-party ad networks. These networks may use cookies or similar technologies to deliver relevant ads. You can control cookie preferences through your browser settings.',
  },
  {
    title: '3. Affiliate Links',
    body: 'Some pages contain affiliate links to third-party financial products (savings accounts, loan refinancing, budgeting apps, hardware wallets). Clicking these links may set a tracking cookie from the affiliate partner. We do not receive or store any personal financial information from these partners.',
  },
  {
    title: '4. Third-Party Services',
    body: 'We may use third-party analytics and advertising providers who have their own privacy policies governing their use of information. We encourage you to review those policies.',
  },
  {
    title: '5. Data Security',
    body: 'Since calculator inputs are never sent to a server, there is no financial data of yours for us to secure or lose in a breach. Any anonymized analytics data we do collect is handled according to industry-standard security practices.',
  },
  {
    title: '6. Changes to This Policy',
    body: 'We may update this Privacy Policy from time to time. Continued use of the site after changes are posted constitutes acceptance of the revised policy.',
  },
  {
    title: '7. Contact Us',
    body: 'If you have questions about this Privacy Policy, please reach out via our Contact page.',
  },
]

function PrivacyPolicy() {
  return (
    <>
      <Seo
        title="Privacy Policy"
        description="Mint Calculator's privacy policy: how we handle data, cookies, analytics, and affiliate links. All calculator inputs stay in your browser and are never stored on our servers."
        path="/privacy-policy"
        schema={breadcrumbSchema([{ name: 'Home', path: '/' }, { name: 'Privacy Policy', path: '/privacy-policy' }])}
      />
      <div className="mx-auto max-w-3xl px-4 py-10 sm:px-6 lg:px-8">
        <Breadcrumbs items={[{ name: 'Home', path: '/' }, { name: 'Privacy Policy', path: '/privacy-policy' }]} />
        <SectionHeading title="Privacy Policy" description="Last updated January 2025" />

        <div className="mt-8 space-y-6">
          {sections.map(s => (
            <div key={s.title}>
              <h3 className="text-sm font-semibold text-slate-100">{s.title}</h3>
              <p className="mt-2 text-sm leading-relaxed text-slate-400">{s.body}</p>
            </div>
          ))}
        </div>
      </div>
    </>
  )
}

export default PrivacyPolicy
